import React, { useEffect } from 'react';
import Header from '../components/Header';
import AboutUs from '../components/AboutUs';
import Footer from '../components/Footer';
import { initSEO } from '../seo';

const AboutUsPage = () => {
  useEffect(() => {
    initSEO('about');
  }, []);

  return (
    <>
      <Header />
      <AboutUs />
      <Footer />
    </>
  );
};

export default AboutUsPage;
